const CourierPlanTemplate = () =>
  import(
    /* webpackChunkName: "time-sheet-courier-plan-template" */ '@/pages/time-sheet/courier-plan-template/index.vue'
  )
const CreateCourierPlanTemplate = () =>
  import(
    /* webpackChunkName: "time-sheet-courier-plan-template" */ '@/pages/time-sheet/courier-plan-template/create.vue'
  )
const EditCourierPlanTemplate = () =>
  import(
    /* webpackChunkName: "time-sheet-courier-plan-template" */ '@/pages/time-sheet/courier-plan-template/edit.vue'
  )

export default {
  path: 'courier-plan-template',
  meta: {
    label: 'courierPlanTemplate',
    auth: 'courierTemplate'
  },
  component: {
    name: 'CourierPlanTemplate',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'TimeSheetCourierPlanTemplate',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: CourierPlanTemplate
    },
    {
      name: 'TimeSheetCreateCourierPlanTemplate',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCourierPlanTemplate
    },
    {
      name: 'TimeSheetEditCourierPlanTemplate',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCourierPlanTemplate,
      props: true
    }
  ]
}
